import { render } from "./SearchIcon.vue?vue&type=template&id=36481c98"
const script = {}

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__